// extracted by mini-css-extract-plugin
var _1 = "SPVsListStyle-module__buy-container___k7aYA";
var _2 = "SPVsListStyle-module__buy-container___k7aYA";
var _3 = "SPVsListStyle-module__company-logo___pktKf";
var _4 = "SPVsListStyle-module__company-logo___pktKf";
var _5 = "SPVsListStyle-module__currency___a9Mg_";
var _6 = "SPVsListStyle-module__logo___ZGAgV";
var _7 = "SPVsListStyle-module__mobile-name___tRsWg";
var _8 = "SPVsListStyle-module__mobile-name___tRsWg";
var _9 = "SPVsListStyle-module__no-items___M2hQM";
var _a = "SPVsListStyle-module__no-items___M2hQM";
var _b = "SPVsListStyle-module__spv-name___q41RU";
var _c = "SPVsListStyle-module__spv-name___q41RU";
var _d = "SPVsListStyle-module__spvs-header___qOXz2";
var _e = "SPVsListStyle-module__spvs-item___G5e92";
var _f = "SPVsListStyle-module__spvs-table___RPzLX";
var _10 = "SPVsListStyle-module__spvs-header___qOXz2";
var _11 = "SPVsListStyle-module__spvs-item___G5e92";
var _12 = "SPVsListStyle-module__spvs-table___RPzLX";
var _13 = "SPVsListStyle-module__table-container___HW8ZP";
var _14 = "SPVsListStyle-module__table-container___HW8ZP";
var _15 = "SPVsListStyle-module__trade-btn___p9HaX";
var _16 = "SPVsListStyle-module__trade-btn___p9HaX";
export { _1 as "buy-container", _2 as "buyContainer", _3 as "company-logo", _4 as "companyLogo", _5 as "currency", _6 as "logo", _7 as "mobile-name", _8 as "mobileName", _9 as "no-items", _a as "noItems", _b as "spv-name", _c as "spvName", _d as "spvs-header", _e as "spvs-item", _f as "spvs-table", _10 as "spvsHeader", _11 as "spvsItem", _12 as "spvsTable", _13 as "table-container", _14 as "tableContainer", _15 as "trade-btn", _16 as "tradeBtn" }
